import './polyfills';
// eslint-disable-next-line no-use-before-define
import { ThemedGlobalStyle } from '@/theme';
import ThemeProvider from '@/theme/ThemeProvider';
import StyledEngineProvider from '@mui/material/StyledEngineProvider';
import * as Sentry from '@sentry/react';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { WagmiProvider } from 'wagmi';
import App from './App';
import './index.css';

import config from '@/common-helpers/web3modalconfig';
import { DefaultChainId } from '@/constant';
import '@/utils/i18n';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BigNumber } from 'bignumber.js';
import { configure } from 'mobx';
import { ApolloMultiClientProvider } from './ApolloMultiClientProvider';

configure({
    enforceActions: 'always',
});

BigNumber.set({ ROUNDING_MODE: BigNumber.ROUND_DOWN });

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

Sentry.init({
    // Disable Sentry - set to true to re-enable
    enabled: false,
    dsn: 'https://569d42bd26e8584554a09ea037d7b914@o4509914474217472.ingest.us.sentry.io/4509914479067136',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/agents\.lazai\.network/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    // Enable logs to be sent to Sentry
    enableLogs: true,
});

root.render(
    <Suspense fallback={<></>}>
        <WagmiProvider config={config}>
            <QueryClientProvider client={queryClient}>
                <RainbowKitProvider
                    initialChain={DefaultChainId}
                    showRecentTransactions={true}
                    appInfo={{
                        appName: 'Lazbubu Protocol',
                    }}
                >
                    <ApolloMultiClientProvider>
                        <StyledEngineProvider injectFirst>
                            <BrowserRouter>
                                <ThemeProvider>
                                    <ThemedGlobalStyle />
                                    <App />
                                </ThemeProvider>
                            </BrowserRouter>
                        </StyledEngineProvider>
                    </ApolloMultiClientProvider>
                </RainbowKitProvider>
            </QueryClientProvider>
        </WagmiProvider>
    </Suspense>,
);
